/** @format */

export const yearRangeFilterModule = 'sis-components.date.yearRangeFilter';

(function () {
    angular.module(yearRangeFilterModule, []).filter('yearRange', yearRange);

    function notNull(value) {
        return angular.isDefined(value) && value !== null;
    }

    function yearRange() {
        return function (input) {
            if (input) {
                var start = notNull(input.startYear) ? input.startYear : null;
                var end = notNull(input.endYear) ? input.endYear : null;
                var retval = '';
                if (notNull(start)) {
                    retval += start;
                }
                if (notNull(start) && notNull(end) && start !== end) {
                    retval += '–';
                }
                if (notNull(end) && start !== end) {
                    retval += end;
                }
                return retval;
            }
            return '';
        };
    }
})();
